// The single source of site constants (template §3: "Site name, URL, and nav appear in a dozen places").

export const SITE = {
  name: "VVR Customer Portal",
  shortName: "VVR Portal",
  // Read from env, never hardcoded — a hardcoded origin is a staging build that emits production URLs.
  url: import.meta.env.VITE_SITE_URL || "",
  description:
    "View your properties, bookings, payments and documents, raise a request and track its progress.",
};

// ═════════════════════════════════════════════════════════════════════════════
// THE PORTAL NAVIGATION — business/20 §44 (CS-2, owner 2026-09-27)
// ═════════════════════════════════════════════════════════════════════════════
//
// "Dashboard · My Purchases · My Properties · My Requests · Documents · Notifications · — · Profile · Security ·
// Logout. Payments and Registration live inside a purchase. The portal never has global Payments / Registration /
// Legal / R&S / Tasks / Employees entries." Declared here once so the sidebar, the drawer and the bottom bar cannot
// drift apart.
//
// ── WHAT CHANGED FROM R&S PART 4 §2 (superseded by business/20 §44, owner CS-2 rulings 2026-09-27) ─────────
//   My Property      SPLIT into My Purchases (what you are buying / bought) and My Properties (what you OWN,
//                    ownership records only — business/19 §58). A purchase is not ownership.
//   Booking          LEFT the navigation: the booking is part of a purchase (purchase detail). /booking redirects.
//   Payments         LEFT the navigation: payments by term live inside the purchase (business/20 §44). /payments
//                    redirects.
//   KYC              LEFT the navigation: purchasers and KYC are a section of the purchase (business/20 §50); /kyc
//                    stays reachable from there and from Action required.
//   Security         NEW (business/19 §72): change password, portal access, account recovery.
//   Timeline         is the Dashboard's Recent activity, with a "View all" page (/timeline) — not a nav row.
//   Support          unchanged: folded into My Requests (Part 4 §15/§29); /support stays reachable.
// Nothing internal appears: no Legal, Sales, Tasks, Employees, Approvals, Audit or Administration destination.
export const NAV = [
  // Part 6 (2026-10-07; owner Part 6 §2): the customer's Home IS the dashboard — one name, "Home", everywhere.
  { to: "/", label: "Home", short: "Home", icon: "bi-speedometer2" },
  { to: "/purchases", label: "My Purchases", short: "Purchases", icon: "bi-bag-check" },
  { to: "/properties", label: "My Properties", short: "Properties", icon: "bi-house-check" },
  { to: "/requests", label: "My Requests", short: "Requests", icon: "bi-inbox" },
  { to: "/documents", label: "Documents", short: "Documents", icon: "bi-folder2" },
  { to: "/notifications", label: "Notifications", short: "Notifications", icon: "bi-bell" },
];

// Below the separator (business/20 §44). Logout is an action, rendered beside these by each navigation.
export const ACCOUNT_NAV = [
  { to: "/profile", label: "Profile", icon: "bi-person" },
  { to: "/security", label: "Security", icon: "bi-shield-lock" },
];

// The phone's bottom bar (business/20 §65–69): Home · Purchases · Properties · Requests · More. "More" opens the
// drawer holding Documents, Notifications, Profile, Security and Logout.
export const MOBILE_PRIMARY = ["/", "/purchases", "/properties", "/requests"];
export const MOBILE_MORE = ["/documents", "/notifications"];
